import { IApplicationRouterExtension } from '../../../../application/ApplicationRouterExtensions';
import { CTFMainPage } from '../../view/user/page/CTFMainPage';
import { CTFRoutes } from './CTFRoutes';

export const CTFRouter: IApplicationRouterExtension[] = [
  {
    path: CTFRoutes.ctfAdminPage,
    pageTitle: 'CTF',
    component: CTFMainPage,
    allowedPermissions: [],
  },
  {
    path: CTFRoutes.ctfAdminStatisticPage,
    pageTitle: 'CTF',
    component: CTFMainPage,
    allowedPermissions: [],
  },
]
